// Date-range rules for the complaint lists; the backend applies the same ones.

const pad = (n) => String(n).padStart(2, '0')

export function toDateString(date) {
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

function parseDate(value) {
    const [y, m, d] = String(value).slice(0, 10).split('-').map(Number)
    return new Date(y, m - 1, d)
}

// Three months after `from`, clamped to the month's last day (Carbon's addMonthsNoOverflow).
export function maxRangeEnd(from) {
    const start = parseDate(from)
    const lastDay = new Date(start.getFullYear(), start.getMonth() + 4, 0).getDate()
    return toDateString(new Date(start.getFullYear(), start.getMonth() + 3, Math.min(start.getDate(), lastDay)))
}

// Returns an error message, or '' when the range is fine. A missing TO means today.
export function rangeError(from, to, label) {
    if (!from) return ''
    const end = to || toDateString(new Date())
    if (end < from) return `${label} Date TO cannot be before FROM.`
    if (end > maxRangeEnd(from)) return `${label} Date range cannot be more than 3 months.`
    return ''
}
